// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__fullWidth___3V9vp{max-width:95% !important;margin:30px auto}.style__content___24HvJ{max-width:1000px;margin:30px auto}\n", "",{"version":3,"sources":["webpack://./src/app/common/PageContainer/style.scss"],"names":[],"mappings":"AAAA,0BACE,wBAAyB,CACzB,gBAAiB,CAClB,wBAGC,gBAAiB,CACjB,gBAAiB","sourcesContent":[".fullWidth {\n  max-width: 95% !important;\n  margin: 30px auto;\n}\n\n.content {\n  max-width: 1000px;\n  margin: 30px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullWidth": "style__fullWidth___3V9vp",
	"content": "style__content___24HvJ"
};
export default ___CSS_LOADER_EXPORT___;
